import { gql } from '@apollo/client';

import { FOOD_COMPONENT_FIELDS } from './fragments';

// The generated document selects the full FoodComponent, sending ingredients and recipe method on every status change.
export const SUBSCRIBE_TO_UPDATE_FOOD_COMPONENT_STATUS_SUBSCRIPTION = gql`
  ${FOOD_COMPONENT_FIELDS}
  subscription SubscribeToUpdateFoodComponentStatus($kitchen: Kitchen) {
    subscribeToUpdateFoodComponentStatus(kitchen: $kitchen) {
      ...FoodComponentFields
    }
  }
`;
